module.exports = __webpack_public_path__ + "82ceec175c8b781e0896325de41082db.png";